import { TextField, Box, Typography, InputLabel } from "@mui/material";
import { useState, useRef, useEffect } from "react";

const plateCharacters = (value) => Array.from(String(value || '').toUpperCase())
  .slice(0, 6)
  .concat(Array(6).fill(''))
  .slice(0, 6);

const PlacaVehiculoInput = ({ onComplete, error, disabled, validationPlaca, defaultValue = '', resetKey }) => {
  const [plate, setPlate] = useState(() => plateCharacters(defaultValue));
  const inputsRef = useRef([]);

  const placeholders = ["A", "B", "C", "1", "2", "3"]; // Placeholders individuales

  useEffect(() => {
    setPlate(plateCharacters(defaultValue));
  }, [defaultValue, resetKey]);

  const handleChange = (index, event) => {
    if (validationPlaca !== undefined) {
      validationPlaca();
    }
    let value = event.target.value.toUpperCase();

    if (index < 3) {
      value = value.replace(/[^A-Z]/g, ""); // Solo letras en los primeros 3
    } else {
      value = value.replace(/[^0-9]/g, ""); // Solo números en los últimos 3
    }

    const newPlate = [...plate];
    newPlate[index] = value;
    setPlate(newPlate);

    // Auto-focus al siguiente input si el valor es válido
    if (index < 5 && value !== "") {
      inputsRef.current[index + 1]?.focus();
    }

    // Llamar a onComplete cuando todos los campos estén llenos
    if (newPlate.every((char) => char !== "")) {
      onComplete(newPlate.join(""));
    }
    if (validationPlaca !== undefined) {
      validationPlaca(newPlate.join(""));
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && !plate[index] && index > 0) {
      // Si el campo está vacío y el usuario presiona Backspace, mover al anterior
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleFocus = (index) => {
    if (plate[index] === "") {
      inputsRef.current[index]?.focus();
    }
  };

  return (
    <>
            <Box display="flex" alignItems="center" gap={1} marginBottom={2}>
            {/* Letras */}
            <InputLabel sx={{ fontWeight: 'bold' }}>PLACA:</InputLabel>
            <Box display="flex" gap={1} sx={{ marginLeft: 1 }}>
              {plate.slice(0, 3).map((char, index) => (
                <TextField
                  disabled={disabled}
                  key={index}
                  inputRef={(el) => (inputsRef.current[index] = el)}
                  value={char}
                  onChange={(e) => handleChange(index, e)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onFocus={() => handleFocus(index)}
                  variant={disabled ? "filled" : "outlined"}
                  size="small"
                  placeholder={placeholders[index]} // Placeholder dinámico
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: "center",
                      textTransform: "uppercase",
                      width: "2.5ch",
                    },
                  }}
                  error={error}
                />
              ))}
            </Box>
    
            {/* Separador en el centro */}
            <Typography variant="h5">·</Typography>
    
            {/* Números */}
            <Box display="flex" gap={1}>
              {plate.slice(3).map((char, index) => (
                <TextField
                  disabled={disabled}
                  key={index + 3}
                  inputRef={(el) => (inputsRef.current[index + 3] = el)}
                  value={char}
                  onChange={(e) => handleChange(index + 3, e)}
                  onKeyDown={(e) => handleKeyDown(index + 3, e)}
                  onFocus={() => handleFocus(index + 3)}
                  variant={disabled ? "filled" : "outlined"}
                  size="small"
                  placeholder={placeholders[index + 3]} // Placeholder dinámico
                  inputProps={{
                    maxLength: 1,
                    style: {
                      textAlign: "center",
                      textTransform: "uppercase",
                      width: "2.5ch",
                    },
                  }}
                  error={error}
                />
              ))}
            </Box>
          </Box>
    </>
  );
};

export default PlacaVehiculoInput;
